import { render, staticRenderFns } from "./nutrition-modal-cmp.vue?vue&type=template&id=560b5d30&scoped=true"
import script from "./nutrition-modal-cmp.vue?vue&type=script&lang=js"
export * from "./nutrition-modal-cmp.vue?vue&type=script&lang=js"
import style0 from "./nutrition-modal-cmp.vue?vue&type=style&index=0&id=560b5d30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560b5d30",
  null
  
)

export default component.exports